import { Flex } from '@chakra-ui/react';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { ScrollTabs } from '~/common/components/ScrollTabs/ScrollTabs';
import { SECTIONS } from '../../components/Listings/ListingPage/ListingPageContent/constants';
import { ListingPageContent } from '../../components/Listings/ListingPage/ListingPageContent/ListingPageContent';
import {
  ListingPageContext,
  ListingPageProvider,
} from '../../components/Listings/ListingPage/ListingPageContext';
import { SIDEBAR_WIDTH_COLLAPSED } from '../../components/PageDetailLayout/SidebarItem';
import { MainLayout } from '../MainLayout';

export const ListingPage = () => {
  const page = (
    <Flex
      alignItems="center"
      backgroundColor="bg.main"
      direction="column"
      flexGrow={1}
      gap={0}
      maxWidth={{
        base: '100vw',
        md: `calc(100vw - ${SIDEBAR_WIDTH_COLLAPSED})`,
      }}
      minHeight="100vh"
      mx="auto"
      width="100%"
    >
      <ListingPageContext.Consumer>
        {({ isLoadingListing }) => {
          if (isLoadingListing) {
            return <CenterSpinner />;
          }

          return <ListingPageContent />;
        }}
      </ListingPageContext.Consumer>
    </Flex>
  );

  return (
    <ListingPageProvider>
      <ListingPageContext.Consumer>
        {({ isLoadingListing, isLoadingReport, reportError }) => {
          const mobileCenterComponent =
            isLoadingListing || isLoadingReport || reportError ? undefined : (
              <ScrollTabs sections={SECTIONS} />
            );

          return (
            <MainLayout
              hideMobileProfileButton
              stickyMobileHeader
              mobileCenterComponent={mobileCenterComponent}
            >
              <Flex w="100%">{page}</Flex>
            </MainLayout>
          );
        }}
      </ListingPageContext.Consumer>
    </ListingPageProvider>
  );
};
